__turbopack_context__.v({
  "alert": "Button-module__3dJGfa__alert",
  "button": "Button-module__3dJGfa__button",
  "expanded": "Button-module__3dJGfa__expanded",
  "large": "Button-module__3dJGfa__large",
  "outlined": "Button-module__3dJGfa__outlined",
  "pulse": "Button-module__3dJGfa__pulse",
  "round": "Button-module__3dJGfa__round",
  "secondary": "Button-module__3dJGfa__secondary",
  "small": "Button-module__3dJGfa__small",
  "tertiary": "Button-module__3dJGfa__tertiary",
  "tiny": "Button-module__3dJGfa__tiny",
});
